import {useEffect, useState} from "react";
import Stats from "./stats";
import Trophy from "./trophy";
import Races from "./races";
import Raffle from "./raffle";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import UserProgress from "../../../components/user-progress";
import {useTranslation} from "react-i18next";
import PublicUserProgress from "../../../components/public-user-progress";
import SvgIcon from "../../../components/svg-icon";

// const tabs = ['statistics', 'trophy', 'races', 'raffles']
const tabs = ['statistics', 'races', 'raffles']
const Statistics = props => {

    const {handleClose} = props
    const {t} = useTranslation()
    const {authenticated} = useSelector(state => state.authenticationReducer)
    const [searchParams, setSearchParams] = useSearchParams()
    const [activeType, setActiveType] = useState('statistics')
    const {modalTab} = useSelector(state => state.globalReducer)
    const [username, setUsername] = useState('')
    const {user: authUser} = useSelector(state => state.authenticationReducer)

    const location = useLocation()
    const getParams = (key) => {
        const searchParams = new URLSearchParams(location?.search);
        return searchParams.get(key);
    }


    useEffect(() => {

        let user = getParams('user')
        setUsername(user ?? authUser?.username)

        searchParams.set('user', user ?? authUser?.username);
        setSearchParams(searchParams);

    }, [location.search])

    useEffect(() => {
        if (modalTab) {
            setActiveType(modalTab)
        }
    }, [modalTab])

    const navigate = useNavigate()

    useEffect(() => {
        if (authenticated) {
            const bdy = document.body
            bdy.classList?.add('modal-open')
            const mdl = document.getElementById('vip-modal')
            mdl.classList?.add('show')
            mdl.style.display = 'block'
            mdl.style.backgroundColor = 'rgba(0,0,0,.7)'
            mdl.classList?.add('modal-fade')


            return () => {
                bdy.classList?.remove('modal-open')
                mdl.classList?.remove('show')
            }
        } else {
            searchParams.set('modal', 'register')
            setSearchParams(searchParams)
        }
    }, [authenticated])


    const handleActiveTab = selected => {
        searchParams.set('tab', selected);
        setSearchParams(searchParams);
    }

    const getDynamicContent = () => {
        switch (activeType) {
            case 'statistics':
                return <Stats username={username}/>

            // case 'trophy':
            //     return <Trophy/>

            case 'races':
                return <Races username={username}/>

            case 'raffles':
                return <Raffle username={username}/>
            default:
                return null;
        }
    }

    return (
        <div
            className="modal fade"
            id="vip-modal"
            aria-labelledby="vip-modal"
            onClick={handleClose}>

            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal__content">
                        <div className="modal__head">
                            <div className="d-flex align-items-center gap-2">
                                <SvgIcon id={'statistics'}/>
                                <h6 className="modal__title">{activeType}</h6>
                            </div>
                            <button
                                onClick={handleClose}
                                type="button"
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>

                        {
                            username === authUser?.username ?
                                <UserProgress username={username}/>
                                :
                                <PublicUserProgress username={username}/>

                        }


                        <ul className="nav nav-tabs tabs-nav tabs-nav--modal">
                            {

                                tabs?.map(tab => (
                                    <li key={tab} className="nav-item">
                                        <button
                                            onClick={e => {
                                                e.stopPropagation()
                                                handleActiveTab(tab)
                                            }}
                                            className={`tabs-nav__btn ${tab === activeType ? 'active' : ''}`}>
                                            {t(`modals.statistics.tabs.${tab}`)}
                                        </button>
                                    </li>
                                ))
                            }
                        </ul>

                        <div className="tab-content">
                            {
                                getDynamicContent()
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}

export default Statistics
